export const STARS_PERCENTS = {
  1: '0%',
  2: '0%',
  3: '0%',
  4: '0%',
  5: '0%',
};

export const MAX_LENGTH = 99;
